import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as qs from 'query-string';

import Login from './login-component';

const mapStateToProps = state => ({
  global: state.Global
});

class LoginRouter extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (<Login showErrors={true} />)
  }
}

export default withRouter(connect(mapStateToProps)(LoginRouter));
